module.exports = __webpack_public_path__ + "static/media/058-death.f30008fe.svg";